import { ContextService } from '../services/context/context.service';
import { ContextStoreService } from '../services/context/context-store.service';
import { PermissionsService } from '../services/permissions/permissions.service';

/**
 * Au reload direct sur une page protégée, le contexte (base active) est
 * normalement restauré par AppComponent (getMe() puis localStorage), de
 * manière asynchrone — rien ne garantit l'ordre avec la navigation initiale,
 * et cette restauration peut échouer silencieusement. Les guards la font donc
 * eux-mêmes, de façon synchrone et sans appel réseau, pour pouvoir statuer
 * immédiatement (pas de page blanche, pas de redirection intempestive).
 */
export function restoreContextFromStorage(
  contextStore: ContextStoreService,
  contextService: ContextService,
  permissionsService: PermissionsService,
): void {
  // Garantit que permissionsService connaît l'utilisateur (isSuperAdmin…).
  if (!permissionsService.currentUser) {
    permissionsService.initUserFromStorage();
  }

  if (contextStore.currentContext?.base) return;

  const stored = localStorage.getItem('activeBase');
  if (!stored) return;
  try {
    const base = JSON.parse(stored);
    if (base?.id) {
      // 1. Restauration minimale immédiate (le guard peut statuer).
      contextStore.setContext({ base, type: 'base' });
      // 2. Enrichissement via le flux normal (organisation, rappels
      //    paiement/crédits, préchargements) — mettra à jour le contexte
      //    si l'organisation diffère.
      const user = JSON.parse(localStorage.getItem('currentUser') || 'null');
      contextService.setActiveBase(base, user);
    }
  } catch { /* activeBase corrompu : le timeout du guard prend le relais */ }
}
